/**
 * Educational user validation (frontend mirror of the backend rule).
 * Eligibility is currently determined purely by the email domain ending in .edu.
 */
export function isEduEmail(email: string | null | undefined): boolean {
  return /\.edu$/i.test((email || '').trim());
}
